import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ActionButton } from "@bitwarden/web-vault/app/components/buttons/gloss-button/actionButton";

@Component({
  selector: "app-cabinet-form",
  templateUrl: "./cabinet-form.component.html",
})
export class CabinetFormComponent {
  @Input() saveButtonOptions: ActionButton;
  @Input() fileName: string;
  @Input() fromDate: string;
  @Input() toDate: string;
  @Output() fileNameChanged = new EventEmitter<string>();
  @Output() dateRangeChanged = new EventEmitter<{ fromDate: string; toDate: string }>();

  onFileNameChanged(fileName: string): void {
    this.fileNameChanged.emit(fileName);
  }

  onDateRangeChanged(range: { fromDate: string; toDate: string }): void {
    this.dateRangeChanged.emit(range);
  }
}
